/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Position_Bottom_Center_TitleInputs */

const en_position_bottom_center_title = /** @type {(inputs: Position_Bottom_Center_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Position: Bottom Center`)
};

const fr_position_bottom_center_title = /** @type {(inputs: Position_Bottom_Center_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Position : En Bas au Centre`)
};

const de_position_bottom_center_title = /** @type {(inputs: Position_Bottom_Center_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Position: Unten Mitte`)
};

const it_position_bottom_center_title = /** @type {(inputs: Position_Bottom_Center_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Posizione: in basso al centro`)
};

const ru_position_bottom_center_title = /** @type {(inputs: Position_Bottom_Center_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Позиция: Нижний центр`)
};

const es_position_bottom_center_title = /** @type {(inputs: Position_Bottom_Center_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Posición: Centro inferior`)
};

const zh_cn2_position_bottom_center_title = /** @type {(inputs: Position_Bottom_Center_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`位置：底部中心`)
};

const ja_position_bottom_center_title = /** @type {(inputs: Position_Bottom_Center_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`位置: 下中央`)
};

const hi_position_bottom_center_title = /** @type {(inputs: Position_Bottom_Center_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`स्थिति: नीचे केंद्र`)
};

const pt_pt2_position_bottom_center_title = /** @type {(inputs: Position_Bottom_Center_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Posição: Centro inferior`)
};

/**
* | output |
* | --- |
* | "Position: Bottom Center" |
*
* @param {Position_Bottom_Center_TitleInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const position_bottom_center_title = /** @type {((inputs?: Position_Bottom_Center_TitleInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Position_Bottom_Center_TitleInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_position_bottom_center_title(inputs)
	if (locale === "de") return de_position_bottom_center_title(inputs)
	if (locale === "it") return it_position_bottom_center_title(inputs)
	if (locale === "ru") return ru_position_bottom_center_title(inputs)
	if (locale === "es") return es_position_bottom_center_title(inputs)
	if (locale === "zh-CN") return zh_cn2_position_bottom_center_title(inputs)
	if (locale === "ja") return ja_position_bottom_center_title(inputs)
	if (locale === "hi") return hi_position_bottom_center_title(inputs)
	if (locale === "pt-PT") return pt_pt2_position_bottom_center_title(inputs)
	return en_position_bottom_center_title(inputs)
});